import type { HeadProps } from "gatsby";
import type { ReactNode } from "react";
import * as React from "react";
import FooterBanner from "../components/Ads/FooterBanner";
import HeaderBanner from "../components/Ads/HeaderBanner";
import LeftPortrait from "../components/Ads/LeftPortrait";
import RightPortrait from "../components/Ads/RightPortrait";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Metadata from "./Metadata";
import { OutboundLink } from "gatsby-plugin-google-gtag";

type Props = {
  element: ReactNode;
  props: {
    location: {
      hash: string;
      pathname: string;
    };
    pageContext: {
      staticQuery?: string;
    };
    data: {
      site?: {
        siteMetadata: {
          title: string;
          description: string;
        };
      };
    };
  };
};

const MainTemplate = ({ element, props }: Props) => {
  const { hash, pathname } = props.location;
  const showAds = hash !== "#noads" && pathname !== "/404/";

  return (
    <>
      <main
        style={{
          display: "flex",
          flex: "1",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Header />

        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-evenly",
            marginTop: "var(--single)",
            minHeight: "600px",
          }}
        >
          {showAds && <LeftPortrait />}

          <div
            className="ElementWrapper"
            style={{
              maxWidth: "90vw",
              minHeight: "600px",
              textAlign: "center",
              width: "100%",
            }}
          >
            {showAds && <HeaderBanner />}
            {element}
            <div>
              <OutboundLink
                href="https://youtube.com/shorts/8gVQ5FW2NMo"
                target="_blank"
              >
                Watch "i want to like..." on YouTube Shorts!
              </OutboundLink>
            </div>
          </div>

          {showAds && <RightPortrait />}
        </div>

        {showAds && <FooterBanner />}

        <div
          style={{
            color: "#999",
            paddingLeft: "5%",
            textAlign: "center",
            width: "90%",
          }}
        >
          <i>Google Feud</i> is a work of parody and not affiliated with Google
          LLC. "Google" and the Google logo are registered trademarks of Google
          LLC.
        </div>

        <Footer />
      </main>
    </>
  );
};

export default MainTemplate;

export const Head = ({
  pageContext,
}: HeadProps & { pageContext: { staticQuery?: string } }) => {
  return <Metadata staticQuery={pageContext.staticQuery} />;
};
